var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270 497.3",
    style: {
      enableBackground: "new 0 0 270 497.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83B3E2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#000000;stroke-width:0.5;}\n\t.st3{fill:#4C702B;}\n\t.st4{fill:#D0DE8E;}\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st6{fill:#F9DB00;}\n\t.st7{fill:#D03632;}\n\t.st8{fill:#1F54B0;}\n\t.st9{fill:#D1D1D1;}\n\t.st10{fill:none;stroke:#000000;stroke-width:0.55;stroke-dasharray:2.77,2.08,2.77,2.08,2.77,2.08;}\n\t.st11{fill:#93B838;}\n\t.st12{fill:#B1CC40;}\n\t.st13{fill:#CAF741;}\n\t.st14{fill:#FEF7CE;}\n\t.st15{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wasser"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.1,137.9c-9.4-3,1-21.4-7-32.8c-5.4-7.7,9.3-6.8,3.3-15.3c-4.5-6.4-10.5,1.1-14.8-3.9 c-4-4.6-10.7-16.9-1.8-23c4.2-2.6,7.3-2.4,12-0.2c5.9,2.7,5.4,3.9,9.2,4.6c3.1,0.5,9.3-0.2,11.8,3.7s-3.6,8.5-4.3,13.3 c-0.5,3.6,3.1,6.8,3.8,11.9c1,6.9-2,7.8-2.2,14.4c-0.2,5.6,2.2,11.5,0.9,18.4C131.2,137.7,125.3,138.9,122.1,137.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "94.5,303.6 222.1,271.7 223,274.5 95.4,306.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "190,284.9 186.1,285.6 184.9,279.4 188.8,278.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.3,278l1.5,1l1.4,7l-1,1.5 M189.6,276.7l-0.9,1.5l1.3,6.9l1.5,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "150.6,295.5 145.4,295.5 145.3,289 150.6,289.3  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.5,459.2c0,3.9-0.5,7-5.5,7c-4.6,0-5.5-3.1-5.5-7s0.5-6.9,5.5-7C157.2,452.1,157.5,455.3,157.5,459.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.9,458.9c0,2.1-1.7,3.7-3.8,3.7s-3.7-1.7-3.7-3.8c0-2,1.7-3.7,3.7-3.7 C154.2,455.1,155.9,456.8,155.9,458.9C155.9,458.9,155.9,458.9,155.9,458.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M142.3,427.3c5-0.9,6,2.7,5.4,9.1c-0.4,4.8-0.8,7.6-3.5,8.7c-4.1,1.7-11.9,4.8-17.1,6.7c-4.9,1.8-9,3.5-11-0.2 s-1.7-5.7,3-5.7c3.4,0,6.1-2.8,11.9-5.5c4.2-1.9,6.4-1.7,7.4-3.6C139,435.7,136.2,428.4,142.3,427.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M146.7,432.1c0,2.1-1.7,3.7-3.8,3.7s-3.7-1.7-3.7-3.8c0-2,1.7-3.7,3.7-3.7C145,428.3,146.7,430,146.7,432.1 C146.7,432.1,146.7,432.1,146.7,432.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M128.2,404.2c-2.2-3.3-0.8-6.7,5.2-8.8c5-1.7,9-4.9,11.5-2.6c3.4,3.1-0.1,7.7-2.9,9.6 C138.7,404.8,130.9,408.2,128.2,404.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M146.3,396.4c-0.3,2-2.2,3.5-4.2,3.2c-2-0.3-3.5-2.2-3.2-4.2c0.3-2,2.1-3.4,4.2-3.2 C145.1,392.5,146.6,394.4,146.3,396.4C146.3,396.4,146.3,396.4,146.3,396.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M135.4,402.1c0,2.1-1.7,3.7-3.8,3.7s-3.7-1.7-3.7-3.8c0-2,1.7-3.7,3.7-3.7C133.7,398.3,135.4,400,135.4,402.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.5,486.9c0,5.8-0.5,10.5-5.5,10.4c-4.6-0.1-5.5-4.7-5.5-10.4s0.5-10.3,5.5-10.4 C157.2,476.3,157.5,481.1,157.5,486.9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Weg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M153.9,53.1l-1.1-1.8c0.5-0.3,12.4-7.4,19.2-7.3s9.3,7.1,9.4,7.4l-2,0.7c-0.1-0.2-2.2-5.9-7.5-6 C165.7,46.1,154,53.1,153.9,53.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166.3,177.2c-1.1-9.5,2.6-14.7,2.7-24.8c0.1-15.5-2-42.1-1.9-57.2c0.2-31.8-14.7-45.1-22.5-51.7 c-6.1-5.2-4.3-9.7-11.7-16.6c-4.5-4.2-13.1-7.1-21.8-6.4c-10.9,0.8-19.1,5.4-22.3,13.4c-2.3,5.8-3.3,17,3,23.9 c4.3,4.7,10.8,3.7,15.3,3.3c4.9-0.5,11.1,4.6,13.7,5.7c3.6,1.5,11.4,0.2,13.7,4.2c2.7,4.7-4.1,8.7-4.2,13.8 c-0.1,3.6,3.8,7.7,4,13.1c0.1,4.7-2,6.8-2.4,12.9c-0.3,4.2,1.4,7.2,1.1,15.8c-0.4,9.7-5.9,12.1-8.6,22c-3,11.4,0.7,16.8,3.3,19.1 c3.4,2.9,7.7,8.4-0.2,16.4s0,24.3,2,42.4c1.3,11.7,1.7,46.8,2.7,50c3.8,12.3,13,11.4,13,11.4l0.1,9.4c0,0-9.8,2.4-13.7,6.1 c-7.5,7-4.3,13.5-5.9,23.5c-1.2,7.3-4,18.7-0.4,25.1c8.4,15,35.1,11.6,38.6-8.4c2.2-12.7,6-17.8,9.6-27.4 c3.4-8.9,4.6-14.6,2.6-18.6c-2.1-4.2-8.9-4.4-12.7-4.2c-4.4,0.2-8.8,1-13,2.2v-7.6c3.1-0.5,6.1-1.3,9-2.4 c6.9-2.7,12.7-5.5,14.8-10.2c2.8-6.3-1.7-18-0.4-33.6c0.6-7.5,4.5-14.9,3.7-24.4C175.8,196.4,168.1,193.9,166.3,177.2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "uebergang"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 102,
    y1: 173.9,
    x2: 185.6,
    y2: 173.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 102,
    y1: 176.9,
    x2: 185.6,
    y2: 176.9
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M150.8,296.8c-5,1.3-9.1,3.2-12.3,9.7c-2.6,5.4-0.1,14.3-2.4,22.9c-2.4,9.2-5.9,19.4,5.7,21.9 c9.1,2,11.1-7.9,14.1-17.1s4.7-15.8,8.3-26C168.5,296.1,164.4,293.3,150.8,296.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M148.7,183.8c-10.2-0.1-12.1,6.9-12.1,13.4c-0.2,10.6,3.3,9.8,3.6,33c0.2,14.9,0.9,25.6,0.3,34.8 s0.2,19.7,11.7,17.7s17.6-7.6,13.8-24.5c-2.2-10.2-3.2-20.7-2.9-31.1c0.1-2.7,1.5-4.7,1-7c-1-4.6-3-3.6-3.3-13.2 C160.3,191.5,160.7,183.9,148.7,183.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M134.1,77.2c-2.5,4.2-5.4,6.8-1.8,12.5c6.6,10.5,2.2,14.2,2.2,21.7s1.5,7.2,0.9,14.4 c-1.1,12.4-2.5,12.2-3.2,19.8c-1.2,10.1,6.1,22.3,15.3,22.3c13.9,0.1,10.5-18.5,10-24.6c-0.7-13-1.1-21.3-1-38.4 c0.1-13.7,1.5-24.3-2.7-29c-3.2-3.6-5.9-0.6-8.9-3.5C140.6,74.2,138.6,75.2,134.1,77.2"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M122.4,67c3.2,0.8,9.8,0.2,12.1,3.4c1.1,1.5,1.6,3.8-0.9,7.5c-3.6,5.4,1.6,7.6,9.8,2.7c7.7-4.6,3.1-5.9,0.6-9 c-5-6.3,2.7-26.2-6.8-30.5c-9.1-4.1-12.3,3.4-18.8,1.8c-5.7-1.5-7.6-6.2-13.3-5.5s-8.4,7.3-8,12.2c0.2,3.5,2.2,6.6,5.4,8.1 c2.7,1.3,7.2,3.2,10.9,4.8C117.5,64.2,119.5,66.3,122.4,67"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M128.7,64.1c3.3-2.1,3.7-6.9,2.2-12c-2-6.9-8.9-5.6-15.2-8.3c-2.7-1.2-8.9-4-12.3-1c-2.5,2.3-2.6,6.2-0.2,8.7 c0.1,0.1,0.2,0.2,0.2,0.2c3.6,3.5,6.5,3.6,11.4,6.4C120.8,61.6,125.4,66.1,128.7,64.1"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M171.1,220.5c-0.8,7.8-2.8,11.7-5.9,11.4c-3.9-0.4-1-7.9-0.9-11.3c0-2-2.5-4.6-2.4-7c0.1-2.5,1.1-3.7,3.3-3.5 C167.8,210.3,171.9,213.2,171.1,220.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M147.9,58.5c2.6-2,6.1,1,7.1,4.4c1,3.2-2,5.1-4,6.2c-3.4,1.8-4.7-0.6-4.5-1.8c0.3-1.6,2.5-1.2,2.5-3.2 S144.8,60.9,147.9,58.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M164.9,190.8c1.5,3,1.3,4.9-1.1,5.7c-3,1.1-2.7-1.2-3.2-2.6c-0.3-0.8-2.4-1.5-2.7-2.5s0-2.4,1.7-3 C161.5,187.7,163.1,187.8,164.9,190.8"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M80.3,148.1l21-1.1L97,163.4l4.9,7.7l-1.1,10.7l-11.8,2c0,0-4,8.5-4.2,9s-3.4,8.1-3.4,8.1l13,16l-4,9.4 l5.5,6.8l-4.2,10.1l-2.2,7.9l8.9,2.8l-3.3,9.6l-18.6-3c0,0,6.4-16.4,5.8-17.1s-6-6.8-6-6.8l8.8-20.3l-12.8-14.9l3.1-9.8l-4-7 l10.8-28L80.3,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M112,108.1c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5 C110.9,105.6,112,106.7,112,108.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M133.5,31.5c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.4-2.5 C132.4,29,133.5,30.1,133.5,31.5C133.5,31.5,133.5,31.5,133.5,31.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M150.5,33.5l9.3-2.9l-0.3-10.1l-6.7-6.7l8-5.8l-9.9-4.2l-6.3,5.6l-7.8-4.6l-18.4,2.4l6.1,8.1l2.5,1.6 c-0.9,1-0.8,2.6,0.3,3.5c0.4,0.4,1,0.6,1.6,0.6c0.5,0,0.9-0.1,1.3-0.4l1.1,3.8l3.2,1.5c-1.1,0.8-1.4,2.4-0.6,3.5 c0.8,1.1,2.4,1.4,3.5,0.6c0.7-0.5,1-1.2,1-2c0-0.1,0-0.1,0-0.2l3.7,1.7L150.5,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M118.4,14.3c0.4-1.3-0.3-2.7-1.6-3.1c-0.3-0.1-0.5-0.1-0.8-0.1l0,0V6.3h-10.9v6.4h1.3 c-0.1,0.3-0.1,0.5-0.1,0.8c0,0.2,0,0.4,0.1,0.6c-0.5,0.1-1,0.4-1.3,0.8c-0.9-1-2.4-1.1-3.5-0.3c-0.4,0.4-0.7,0.9-0.8,1.5 c-1.3-0.6-2.7,0-3.3,1.2c-0.6,1.3,0,2.7,1.2,3.3c1.3,0.6,2.7,0,3.3-1.2c0.1-0.2,0.2-0.4,0.2-0.6c0.3,0.1,0.7,0.2,1,0.2 c0.7,0,1.4-0.3,1.9-0.9c0.5,0.5,1.1,0.9,1.9,0.9c1.4,0,2.5-1.1,2.5-2.5c0-0.2,0-0.4-0.1-0.6c1.2-0.2,2-1.3,2-2.4 c0-0.3-0.1-0.5-0.1-0.8h2.7c-0.1,0.3-0.2,0.6-0.2,0.9c0,1.1,0.7,2.1,1.8,2.4c-0.1,0.2-0.1,0.4-0.1,0.7c0,1.4,1.1,2.5,2.5,2.5 c1.4,0,2.5-1.1,2.5-2.5C120.2,15.5,119.5,14.6,118.4,14.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M111.7,97.8c0-0.5-0.2-1-0.5-1.5c0.4-0.4,0.6-1,0.6-1.6c0-1.4-1.1-2.5-2.5-2.5c0,0,0,0,0,0 c-0.7,0-1.3,0.3-1.8,0.8c-0.2-1.2-1.2-2.1-2.4-2.1c-0.6,0-1.2,0.2-1.7,0.7c-0.4-0.4-1-0.7-1.7-0.7c-1.2,0-2.2,0.9-2.4,2.1l-2.9-0.5 l-3.3-7l-7.1-18.6l-5.6-18.5l0.6-18.7l4.9-7l16.8-9.2l-9.5-6.3l-7.5,4.4l-8.8-3.1l0.2,8.1l-4.9,9.4l0.4,26.4l12.8,40.4l-5.8,6 l3.1,5.8l1.7,9.6c0,0,7.7,6.9,7.1,7.1s0.3,9.7,0.3,9.7l-5.6,17.9l-7.5-0.6l2.8,9.1l-4.1,10.5l24.8,6.9l2-8.5l0.5-32.8l5.3-17 l-7.3-6.8l1.2-4c0.4,0.9,1.3,1.4,2.2,1.4c1.3,0,2.4-1.1,2.5-2.4c1.3-0.1,2.3-1.2,2.3-2.5c0-0.7-0.3-1.3-0.7-1.8 C111.2,99.7,111.7,98.8,111.7,97.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M116.1,468.1c1.4,0,2.6-1.2,2.5-2.7c0-1.2-0.9-2.2-2-2.5c0-0.1,0-0.3,0-0.4c0-1.2-0.9-2.3-2.1-2.5 c0.2-0.4,0.3-0.8,0.3-1.3c0-1.3-0.9-2.3-2.2-2.5c0.8-1.1,0.5-2.7-0.6-3.5s-2.7-0.5-3.5,0.6c-0.2,0.3-0.4,0.7-0.4,1 c-0.4-0.3-0.9-0.5-1.4-0.5c-1.4,0.1-2.4,1.3-2.3,2.7c0.1,1.2,1.1,2.2,2.3,2.3h0.2c0.1,0.5,0.4,1,0.8,1.4c-0.2,0.3-0.2,0.7-0.2,1.1 v0.1l-3.5-0.3l-6.8-5.2l-14.3-12.1l6.8-4.6l-9.6-6.3l6.2-14.9l-3-37.2l-6.6-19.3l6.1-6.3l-4.9-7.1l-5.6-36.5l18.5,2.3l12.1-15.7 l-5.5-8.5l-3.2-7.8l1.3-18.2l-20.4-2.9l3.8,9.8l-5.7,9.2l6.2,7.7l-6.9,7.5c0,0-4.9,9-5.1,9.6s-6.1,7.8-6.1,7.8l4.9,25.6l0.9,23.6 l8.5,25.9l2.3,18.3l-8.7-0.5l1.6,22.6l3.3,8.8l-9.8,4.4l-0.2,11l7.5,5.7l8.2,5.7l-2.7,9.8l10.3-3.3l11.9,10.4 c-0.3,0.4-0.4,0.9-0.4,1.5c0,1.4,1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6c0-1.1-0.8-2.2-1.9-2.5l0.1-0.2c0.2,0.1,0.5,0.1,0.7,0.1 c1.4,0,2.6-1.2,2.6-2.6c0-0.9-0.5-1.8-1.4-2.3l0,0c0.4,0.2,0.8,0.3,1.2,0.3c1.1,0,2-0.7,2.4-1.7c0.6,1.3,2.1,1.9,3.4,1.3 c0.9-0.4,1.5-1.3,1.5-2.4c0-0.1,0-0.3,0-0.5h0.1c0.3,1.4,1.6,2.3,3,2.1c1.4-0.3,2.3-1.6,2.1-3c-0.2-1.1-1-1.9-2.1-2.1l0.1-0.4 C115.9,468.1,116,468.1,116.1,468.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M160.8,422.3c0,1.4-1.1,2.5-2.5,2.4s-2.5-1.1-2.4-2.5c0-1.4,1.1-2.4,2.5-2.4 C159.7,419.8,160.8,420.9,160.8,422.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M171.4,414.7c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5 C170.3,412.3,171.4,413.4,171.4,414.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M118.1,461.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C116,456.6,118.1,458.7,118.1,461.2C118.1,461.2,118.1,461.2,118.1,461.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M125.3,459.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C123.3,455.1,125.4,457.2,125.3,459.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M134.5,457.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C132.4,452.6,134.5,454.7,134.5,457.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M144.2,457.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C142.1,452.6,144.2,454.7,144.2,457.3C144.2,457.3,144.2,457.3,144.2,457.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M141.4,450.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C139.3,445.6,141.4,447.7,141.4,450.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M171.8,444.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C169.8,439.7,171.9,441.8,171.8,444.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M179.1,442.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C177,437.8,179.1,439.9,179.1,442.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M166.9,464.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C164.9,459.7,166.9,461.8,166.9,464.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M186.4,443.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C184.3,438.8,186.4,440.9,186.4,443.4C186.4,443.4,186.4,443.4,186.4,443.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M205.2,441.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C203.2,436.7,205.2,438.8,205.2,441.4C205.2,441.4,205.2,441.4,205.2,441.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M214.4,439c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C212.3,434.3,214.4,436.4,214.4,439C214.4,439,214.4,439,214.4,439"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M196,442.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C193.9,438.2,196,440.3,196,442.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M219.7,426.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C217.6,421.8,219.7,423.9,219.7,426.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M175.7,422.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C173.6,417.5,175.7,419.6,175.7,422.1C175.7,422.1,175.7,422.1,175.7,422.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M227.7,398.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C225.6,393.8,227.7,395.9,227.7,398.5C227.7,398.5,227.7,398.5,227.7,398.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M168.8,404.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C166.7,399.9,168.8,402,168.8,404.6C168.8,404.6,168.8,404.6,168.8,404.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.2,390.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C87.1,386.3,89.2,388.4,89.2,390.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M87.5,381.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C85.4,376.7,87.5,378.8,87.5,381.3C87.5,381.3,87.5,381.3,87.5,381.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.8,372c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C82.7,367.3,84.8,369.4,84.8,372"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M80.7,363.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C78.6,358.5,80.7,360.6,80.7,363.2C80.7,363.2,80.7,363.2,80.7,363.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82.1,347.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C80,342.5,82.1,344.6,82.1,347.2C82.1,347.2,82.1,347.2,82.1,347.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M78.3,354.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C76.2,349.9,78.3,352,78.3,354.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M70.3,353.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C68.2,348.8,70.3,350.9,70.3,353.5C70.3,353.5,70.3,353.5,70.3,353.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M72.6,346.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C70.5,341.9,72.6,344,72.6,346.5C72.6,346.5,72.6,346.5,72.6,346.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M69.8,337.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C67.7,332.7,69.8,334.8,69.8,337.4C69.8,337.4,69.8,337.4,69.8,337.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M87,355.6c0,2.6-2.1,4.7-4.6,4.7c-2.6,0-4.7-2.1-4.7-4.6c0-2.6,2.1-4.6,4.6-4.7C84.9,351,87,353.1,87,355.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M79,339c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C76.9,334.3,79,336.4,79,339 C79,339,79,339,79,339"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M79.2,330.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C77.2,325.5,79.3,327.6,79.2,330.2C79.2,330.2,79.2,330.2,79.2,330.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M70.4,327.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C68.4,323.2,70.5,325.3,70.4,327.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M77.3,320.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C75.3,316.3,77.4,318.4,77.3,320.9C77.4,320.9,77.4,320.9,77.3,320.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M67.3,319.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C65.2,315.1,67.3,317.2,67.3,319.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M66.7,310.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C64.6,306,66.7,308.1,66.7,310.7C66.7,310.7,66.7,310.7,66.7,310.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M69,441.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6C66.9,437,69,439.1,69,441.6 C69,441.6,69,441.6,69,441.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M94.2,450.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C92.2,445.4,94.2,447.5,94.2,450.1C94.2,450.1,94.2,450.1,94.2,450.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M86.2,444.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C84.2,439.5,86.3,441.6,86.2,444.2C86.2,444.2,86.2,444.2,86.2,444.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M78,437.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C75.9,432.9,78,435,78,437.6 C78,437.6,78,437.6,78,437.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M77.4,431.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C75.4,427.2,77.5,429.3,77.4,431.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.4,428.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C74.3,423.6,76.4,425.7,76.4,428.3C76.4,428.3,76.4,428.3,76.4,428.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M94.3,439.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C92.2,434.4,94.3,436.5,94.3,439.1C94.3,439.1,94.3,439.1,94.3,439.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M86.4,434.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C84.3,430,86.4,432.1,86.4,434.7C86.4,434.7,86.4,434.7,86.4,434.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M94.7,428.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C92.6,424.2,94.7,426.3,94.7,428.9C94.7,428.9,94.7,428.9,94.7,428.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82.1,416.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C80,412.1,82.1,414.2,82.1,416.8C82.1,416.8,82.1,416.8,82.1,416.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M73.6,405.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C71.6,400.4,73.7,402.5,73.6,405.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M73.6,411.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6c0,0,0,0,0,0 C71.6,407,73.6,409.1,73.6,411.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M72.2,393.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C70.1,389.1,72.2,391.2,72.2,393.8C72.2,393.8,72.2,393.8,72.2,393.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M71.5,385.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C69.4,381.2,71.5,383.3,71.5,385.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M69.8,377.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C67.7,372.6,69.8,374.7,69.8,377.3C69.8,377.3,69.8,377.3,69.8,377.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M80.6,398.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C78.5,393.4,80.6,395.5,80.6,398.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M91.2,419.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C89.1,414.9,91.2,417,91.2,419.6C91.2,419.6,91.2,419.6,91.2,419.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M85.5,426c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C83.5,421.4,85.5,423.5,85.5,426C85.5,426,85.5,426,85.5,426"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M91.3,410c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C89.2,405.3,91.3,407.4,91.3,410"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82.3,407.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C80.3,403.2,82.4,405.3,82.3,407.8C82.3,407.8,82.3,407.8,82.3,407.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.1,400.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C87,396.1,89.1,398.2,89.1,400.8C89.1,400.7,89.1,400.7,89.1,400.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M80.3,388.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C78.2,383.8,80.3,385.9,80.3,388.5C80.3,388.5,80.3,388.5,80.3,388.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M78,379.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C75.9,374.6,78,376.7,78,379.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.3,370.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C74.2,365.9,76.3,368,76.3,370.6C76.3,370.6,76.3,370.6,76.3,370.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M71.4,361.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C69.3,357.2,71.4,359.3,71.4,361.9C71.4,361.8,71.4,361.8,71.4,361.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M81.9,473.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C79.8,468.7,81.9,470.8,81.9,473.4C81.9,473.4,81.9,473.4,81.9,473.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M91.4,470c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C89.3,465.3,91.4,467.4,91.4,470C91.4,470,91.4,470,91.4,470"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.5,475.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C97.4,470.5,99.5,472.6,99.5,475.2C99.5,475.2,99.5,475.2,99.5,475.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M110.6,461.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C108.5,456.7,110.6,458.8,110.6,461.4C110.6,461.4,110.6,461.4,110.6,461.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M101.8,465.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C99.7,461.1,101.8,463.2,101.8,465.8C101.8,465.8,101.8,465.8,101.8,465.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M102.5,455.7c0,2.6-2.2,4.6-4.7,4.6s-4.6-2.2-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C100.5,451,102.6,453.1,102.5,455.7C102.5,455.7,102.5,455.7,102.5,455.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M93.6,460.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C91.5,455.7,93.6,457.8,93.6,460.4C93.6,460.4,93.6,460.4,93.6,460.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M83.8,463.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C81.8,459.1,83.8,461.3,83.8,463.8C83.8,463.8,83.8,463.8,83.8,463.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.3,457.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C74.3,453.2,76.4,455.3,76.3,457.9C76.3,457.9,76.3,457.9,76.3,457.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M69.9,451.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C67.9,446.4,69.9,448.5,69.9,451.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M85.3,454c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C83.2,449.3,85.3,451.4,85.3,454C85.3,454,85.3,454,85.3,454"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.8,447.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C74.7,442.7,76.8,444.8,76.8,447.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M183.3,282.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C181.2,278.1,183.3,280.2,183.3,282.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M190.5,247c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C188.4,242.3,190.5,244.4,190.5,247C190.5,247,190.5,247,190.5,247"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M197.8,172.4c0.3,2.5-1.5,4.9-4,5.2s-4.9-1.5-5.2-4c-0.3-2.5,1.4-4.8,3.9-5.2 C195.1,168.1,197.4,169.9,197.8,172.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M178.8,172.6c0.3,2.5-1.5,4.9-4,5.2s-4.9-1.5-5.2-4c-0.3-2.5,1.4-4.8,3.9-5.2 C176.1,168.3,178.4,170.1,178.8,172.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M188.2,172.5c0.3,2.5-1.5,4.9-4,5.2s-4.9-1.5-5.2-4c-0.3-2.5,1.4-4.8,3.9-5.2 C185.5,168.1,187.8,169.9,188.2,172.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M108.1,282.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C106.1,277.5,108.1,279.6,108.1,282.1C108.1,282.1,108.1,282.1,108.1,282.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M103.3,290.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C101.2,285.6,103.3,287.7,103.3,290.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M97.4,297.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C95.4,293.2,97.5,295.3,97.4,297.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M91.4,305.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C89.3,300.8,91.4,302.9,91.4,305.5C91.4,305.5,91.4,305.5,91.4,305.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M81.4,303.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C79.3,299.1,81.4,301.2,81.4,303.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M71.4,303c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C69.4,298.3,71.4,300.4,71.4,303C71.4,303,71.4,303,71.4,303"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.1,311.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C74,306.9,76.1,309,76.1,311.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M86,313.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C83.9,308.9,86,311,86,313.6 C86,313.6,86,313.6,86,313.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M106.9,299.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C104.8,294.7,106.9,296.8,106.9,299.3C106.9,299.3,106.9,299.3,106.9,299.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M101.1,306.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C99,302.3,101.1,304.4,101.1,306.9C101.1,306.9,101.1,306.9,101.1,306.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M95.7,314.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C93.7,309.9,95.7,312,95.7,314.5C95.7,314.5,95.7,314.5,95.7,314.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M117.4,295.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C115.3,290.7,117.4,292.8,117.4,295.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M126.6,292.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C124.5,287.5,126.6,289.6,126.6,292.2C126.6,292.2,126.6,292.2,126.6,292.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M135.6,289.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C133.5,285.1,135.6,287.2,135.6,289.8C135.6,289.8,135.6,289.8,135.6,289.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M228.4,270.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C226.4,265.9,228.4,268,228.4,270.6C228.4,270.6,228.4,270.6,228.4,270.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M90.6,233.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C88.6,228.9,90.7,231,90.6,233.5C90.7,233.5,90.7,233.5,90.6,233.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M100.6,233.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6c0,0,0,0,0,0 C98.6,228.9,100.7,231,100.6,233.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M95.7,241.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C93.7,237,95.7,239.1,95.7,241.6C95.7,241.6,95.7,241.6,95.7,241.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M86.5,242.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C84.4,238.2,86.5,240.3,86.5,242.9C86.5,242.9,86.5,242.9,86.5,242.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M83.3,252c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C81.3,247.3,83.4,249.4,83.3,252"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M93.1,251.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C91,246.5,93.1,248.6,93.1,251.2C93.1,251.2,93.1,251.2,93.1,251.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M101.8,246.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C99.7,242.1,101.8,244.2,101.8,246.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M101.8,253.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C99.7,248.5,101.8,250.6,101.8,253.2C101.8,253.2,101.8,253.2,101.8,253.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.1,262.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C97.1,257.6,99.1,259.7,99.1,262.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.4,260.3c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6C87.3,255.6,89.4,257.7,89.4,260.3 C89.4,260.3,89.4,260.3,89.4,260.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M79.7,261.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C77.6,256.6,79.7,258.7,79.7,261.3C79.7,261.3,79.7,261.3,79.7,261.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82.6,270.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C80.5,265.9,82.6,268,82.6,270.6C82.6,270.6,82.6,270.6,82.6,270.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M92.1,270.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C90,265.4,92.1,267.5,92.1,270.1C92.1,270.1,92.1,270.1,92.1,270.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M101.3,271.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C99.2,267.2,101.3,269.3,101.3,271.8C101.3,271.8,101.3,271.8,101.3,271.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M79.4,279.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C77.4,275,79.5,277.1,79.4,279.7C79.5,279.7,79.5,279.7,79.4,279.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.2,279.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C87.1,275,89.2,277.1,89.2,279.7C89.2,279.7,89.2,279.7,89.2,279.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.1,280.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C97.1,276.2,99.2,278.3,99.1,280.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M94,288.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C91.9,283.8,94,285.9,94,288.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M83.8,288c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C81.8,283.3,83.8,285.4,83.8,288"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M77.8,294.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C75.7,290.2,77.8,292.3,77.8,294.9C77.8,294.9,77.8,294.9,77.8,294.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M88.2,296.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C86.1,292,88.2,294.1,88.2,296.6C88.2,296.6,88.2,296.6,88.2,296.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M121.9,175.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C119.8,170.4,121.9,172.5,121.9,175.1C121.9,175.1,121.9,175.1,121.9,175.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M124.6,169.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C122.6,164.9,124.7,167,124.6,169.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M132,175.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C129.9,170.9,132,173,132,175.6C132,175.6,132,175.6,132,175.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M107.5,173.4c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C105.4,168.7,107.5,170.8,107.5,173.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M114.2,181c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C112.1,176.3,114.2,178.4,114.2,181"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M103.8,181.7c0,2.6-2.2,4.6-4.7,4.6c-2.6,0-4.6-2.2-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C101.7,177,103.8,179.1,103.8,181.7C103.8,181.7,103.8,181.7,103.8,181.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M94,182.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C91.9,177.8,94,179.9,94,182.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.3,183.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C82.2,178.8,84.3,180.9,84.3,183.4C84.3,183.4,84.3,183.4,84.3,183.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M74.8,184.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C72.8,180,74.8,182.1,74.8,184.7C74.8,184.7,74.8,184.7,74.8,184.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M79.9,192.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C77.9,188.1,79.9,190.2,79.9,192.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.3,201.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C74.2,197.2,76.3,199.3,76.3,201.9C76.3,201.9,76.3,201.9,76.3,201.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82.6,209.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C80.6,204.8,82.7,206.9,82.6,209.5C82.7,209.5,82.7,209.5,82.6,209.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M92.4,199.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C90.3,194.7,92.4,196.8,92.4,199.4C92.4,199.4,92.4,199.4,92.4,199.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M98.9,194.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C96.8,189.9,98.9,192,98.9,194.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.9,191.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C87.8,186.6,89.9,188.7,89.9,191.3C89.9,191.3,89.9,191.3,89.9,191.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M86,200.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C83.9,195.7,86,197.8,86,200.4 C86,200.4,86,200.4,86,200.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M92.1,208.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C90,203.6,92.1,205.7,92.1,208.2C92.1,208.2,92.1,208.2,92.1,208.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M97.9,215.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C95.8,211.2,97.9,213.3,97.9,215.9C97.9,215.9,97.9,215.9,97.9,215.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M88.2,217.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C86.1,212.7,88.2,214.8,88.2,217.3C88.2,217.3,88.2,217.3,88.2,217.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M94.5,224.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C92.4,220.3,94.5,222.4,94.5,224.9C94.5,224.9,94.5,224.9,94.5,224.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.1,225.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C82,221,84.1,223.1,84.1,225.7C84.1,225.7,84.1,225.7,84.1,225.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M80.7,235c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C78.6,230.3,80.7,232.4,80.7,235"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M87,123.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C84.9,119,87,121.1,87,123.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M112.2,115.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C110.1,110.5,112.2,112.6,112.2,115.1C112.2,115.1,112.2,115.1,112.2,115.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M96.1,130.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C94,126.2,96.1,128.3,96.1,130.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M95.8,121.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C93.8,116.7,95.8,118.8,95.8,121.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M96,102.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C93.9,97.9,96,100,96,102.6 C96,102.6,96,102.6,96,102.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M91.2,94c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C89.1,89.3,91.2,91.4,91.2,94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M101,110.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C98.9,106,101,108.1,101,110.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M112.2,124.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C110.2,119.5,112.3,121.6,112.2,124.2C112.2,124.2,112.2,124.2,112.2,124.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M93.1,139.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C91,134.5,93.1,136.6,93.1,139.2C93.1,139.2,93.1,139.2,93.1,139.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M104.2,137.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C102.1,133.1,104.2,135.2,104.2,137.8C104.2,137.8,104.2,137.8,104.2,137.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M104.9,118.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C102.8,114.2,104.9,116.3,104.9,118.9C104.9,118.9,104.9,118.9,104.9,118.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M103.9,128.8c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C101.9,124.1,103.9,126.2,103.9,128.8C103.9,128.8,103.9,128.8,103.9,128.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M112.5,133.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C110.4,128.7,112.5,130.8,112.5,133.4C112.5,133.4,112.5,133.4,112.5,133.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M112.2,142.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C110.2,137.8,112.3,139.9,112.2,142.5C112.3,142.5,112.3,142.5,112.2,142.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M115,154.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C112.9,149.9,115,152,115,154.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M109.3,150.1c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C107.2,145.4,109.3,147.5,109.3,150.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.6,147.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C82.5,142.9,84.6,145,84.6,147.6C84.6,147.6,84.6,147.6,84.6,147.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M91.1,148.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C89,143.5,91.1,145.6,91.1,148.2C91.1,148.2,91.1,148.2,91.1,148.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M100.5,145.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C98.4,141.2,100.5,143.3,100.5,145.9C100.5,145.8,100.5,145.8,100.5,145.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M85.5,157.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C83.5,152.5,85.5,154.6,85.5,157.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M124,142.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C121.9,138.2,124,140.3,124,142.9C124,142.9,124,142.9,124,142.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M108.6,159.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C106.5,154.9,108.6,157,108.6,159.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M115.5,168.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C113.4,164.2,115.5,166.3,115.5,168.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M109,165c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C106.9,160.3,109,162.4,109,165 C109,165,109,165,109,165"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M81.9,166.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C79.8,161.8,81.9,163.9,81.9,166.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M78.2,175.6c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6C76.2,170.9,78.2,173,78.2,175.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M87.7,174.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C85.6,169.7,87.7,171.8,87.7,174.4C87.7,174.4,87.7,174.4,87.7,174.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M90.6,165.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C88.6,161.1,90.7,163.2,90.6,165.8C90.6,165.8,90.6,165.8,90.6,165.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M100.2,155.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C98.1,150.4,100.2,152.5,100.2,155.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M94.4,156.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C92.3,152.2,94.4,154.3,94.4,156.9C94.4,156.9,94.4,156.9,94.4,156.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M97.9,173.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C95.8,169.3,97.9,171.4,97.9,173.9C97.9,173.9,97.9,173.9,97.9,173.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.5,164.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C97.4,160,99.5,162.1,99.5,164.7C99.5,164.7,99.5,164.7,99.5,164.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M91.8,113c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C89.8,108.3,91.9,110.4,91.8,113C91.9,113,91.9,113,91.8,113"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M90.4,22.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C88.3,17.7,90.4,19.8,90.4,22.4C90.4,22.4,90.4,22.4,90.4,22.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.5,25.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C74.5,21.1,76.5,23.2,76.5,25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.6,30.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C82.5,25.6,84.6,27.7,84.6,30.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.5,35.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C74.5,30.7,76.5,32.8,76.5,35.4C76.5,35.4,76.5,35.4,76.5,35.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.8,39.8c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C82.7,35.1,84.8,37.2,84.8,39.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.8,45c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C74.7,40.3,76.8,42.4,76.8,45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M77,54.8c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C74.9,50.1,77,52.2,77,54.8 C77,54.8,77,54.8,77,54.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M85.3,49.4c0,2.6-2.1,4.6-4.7,4.6C78,54,76,51.9,76,49.3c0-2.5,2.1-4.6,4.6-4.6 C83.2,44.7,85.3,46.8,85.3,49.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.2,57.7c0,2.6-2.2,4.6-4.7,4.6s-4.6-2.2-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C87.2,53,89.3,55.1,89.2,57.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82,69.7c0,2.6-2.2,4.6-4.7,4.6s-4.6-2.2-4.6-4.7c0-2.5,2.1-4.6,4.7-4.6C79.9,65,82,67.1,82,69.7 C82,69.7,82,69.7,82,69.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M81.7,62.7c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C79.6,58.1,81.7,60.2,81.7,62.7 C81.7,62.7,81.7,62.7,81.7,62.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M95.5,69.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C93.4,64.7,95.5,66.8,95.5,69.3C95.5,69.3,95.5,69.3,95.5,69.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M90.8,66.7c0,2.6-2.2,4.6-4.7,4.6c-2.6,0-4.6-2.2-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C88.8,62,90.9,64.1,90.8,66.7 C90.8,66.7,90.8,66.7,90.8,66.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M94.5,78.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C92.5,74.1,94.5,76.2,94.5,78.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M85.3,76.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C83.3,72.2,85.3,74.3,85.3,76.8C85.3,76.8,85.3,76.8,85.3,76.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M87.6,86.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C85.6,81.4,87.7,83.5,87.6,86.1C87.7,86,87.7,86,87.6,86.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M96.1,85.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C94,80.9,96.1,83,96.1,85.6 C96.1,85.6,96.1,85.6,96.1,85.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M83.5,99.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C81.4,94.6,83.5,96.7,83.5,99.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M90.6,105.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C88.5,100.6,90.6,102.7,90.6,105.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M102.8,101.5c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C100.7,96.8,102.8,98.9,102.8,101.5C102.8,101.5,102.8,101.5,102.8,101.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M109.2,97.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C107.2,93.2,109.3,95.3,109.2,97.9C109.2,97.9,109.2,97.9,109.2,97.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M100.6,92.1c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C98.6,87.4,100.7,89.5,100.6,92.1C100.7,92,100.7,92,100.6,92.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M109.6,107.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C107.5,103,109.6,105.1,109.6,107.7C109.6,107.7,109.6,107.7,109.6,107.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M164.5,7.2c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C162.4,2.5,164.5,4.6,164.5,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M163.8,20.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6 C161.7,16,163.8,18.1,163.8,20.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M157.5,13.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C155.4,9.1,157.5,11.2,157.5,13.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M154.8,22.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C152.7,18.2,154.8,20.3,154.8,22.9C154.8,22.9,154.8,22.9,154.8,22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M146.8,29.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C144.7,24.6,146.8,26.7,146.8,29.3C146.8,29.3,146.8,29.3,146.8,29.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M136.1,23.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C134,18.7,136.1,20.8,136.1,23.4C136.1,23.4,136.1,23.4,136.1,23.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M145.6,19.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C143.5,15.3,145.6,17.4,145.6,19.9C145.6,19.9,145.6,19.9,145.6,19.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M148.7,10.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C146.6,5.7,148.7,7.8,148.7,10.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M141.5,4.7c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.6-2.1-4.6-4.7s2.1-4.7,4.6-4.7C139.4,0,141.5,2.1,141.5,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M138.4,14c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C136.3,9.3,138.4,11.4,138.4,14C138.4,14,138.4,14,138.4,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M132.4,6.3c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C130.3,1.6,132.4,3.7,132.4,6.3C132.4,6.3,132.4,6.3,132.4,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M129,15.6c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C126.9,11,129,13.1,129,15.6 C129,15.6,129,15.6,129,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M123.5,7.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C121.4,2.9,123.5,5,123.5,7.6 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M116.9,14.8c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C114.8,10.1,116.9,12.2,116.9,14.8 C116.9,14.8,116.9,14.8,116.9,14.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M114.1,5.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C112.1,1.2,114.2,3.3,114.1,5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M98.9,6.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C96.8,2.2,98.9,4.3,98.9,6.9 C98.9,6.9,98.9,6.9,98.9,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M107.4,12.8c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C105.3,8.1,107.4,10.2,107.4,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M99.1,17.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C97.1,12.8,99.1,14.9,99.1,17.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M90.9,12.6c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C88.8,7.9,90.9,10,90.9,12.6 C90.9,12.6,90.9,12.6,90.9,12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82.1,7.9c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6C80,3.2,82.1,5.3,82.1,7.9 C82.1,7.9,82.1,7.9,82.1,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M81.9,17.5c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C79.8,12.8,81.9,14.9,81.9,17.5C81.9,17.5,81.9,17.5,81.9,17.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M181.4,70.7c0,2.6-2.1,4.6-4.7,4.6s-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6C179.3,66,181.4,68.1,181.4,70.7 C181.4,70.7,181.4,70.7,181.4,70.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M175.9,62.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C173.8,58,175.9,60.1,175.9,62.7C175.9,62.7,175.9,62.7,175.9,62.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M167.7,57.8c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C165.6,53.1,167.7,55.2,167.7,57.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M175.7,53.4c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.5,2.1-4.6,4.6-4.6 C173.6,48.7,175.7,50.8,175.7,53.4C175.7,53.4,175.7,53.4,175.7,53.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M156,32.7c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.7-4.6C153.9,28,156,30.1,156,32.7 C156,32.7,156,32.7,156,32.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M165.5,30c0,2.6-2.1,4.6-4.7,4.6c-2.6,0-4.6-2.1-4.6-4.7c0-2.6,2.1-4.6,4.6-4.6 C163.4,25.3,165.5,27.4,165.5,30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M155.5,3.7c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.6-2.1-4.6-4.7s2.1-4.7,4.6-4.7C153.4-0.9,155.5,1.2,155.5,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M127.1,280c0,1.4-1.2,2.6-2.6,2.5c-1.4,0-2.6-1.2-2.5-2.6c0-1.4,1.2-2.5,2.6-2.5 C125.9,277.4,127.1,278.6,127.1,280C127.1,280,127.1,280,127.1,280"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M125.3,268.8c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C124.2,266.2,125.4,267.4,125.3,268.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M124.3,258.2c0,1.4-1.2,2.6-2.6,2.5s-2.6-1.2-2.5-2.6c0-1.4,1.2-2.5,2.6-2.5 C123.2,255.6,124.3,256.8,124.3,258.2C124.3,258.2,124.3,258.2,124.3,258.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M123.1,248.6c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C121.9,246,123.1,247.1,123.1,248.6C123.1,248.6,123.1,248.6,123.1,248.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M122.2,241.8c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C121.1,239.2,122.3,240.3,122.2,241.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M121.8,236.6c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C120.6,234,121.8,235.2,121.8,236.6C121.8,236.6,121.8,236.6,121.8,236.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M120.7,225.6c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C119.6,223,120.7,224.2,120.7,225.6C120.7,225.6,120.7,225.6,120.7,225.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M119.8,220.5c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C118.7,217.9,119.8,219.1,119.8,220.5C119.8,220.5,119.8,220.5,119.8,220.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M119.7,214.1c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C118.5,211.5,119.7,212.6,119.7,214.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M118.3,206.9c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C117.1,204.3,118.3,205.5,118.3,206.9C118.3,206.9,118.3,206.9,118.3,206.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M118.2,201.3c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C117.1,198.7,118.2,199.9,118.2,201.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M117.1,195.4c0,1.4-1.2,2.6-2.6,2.5c-1.4,0-2.6-1.2-2.5-2.6c0-1.4,1.2-2.5,2.6-2.5 C115.9,192.8,117.1,193.9,117.1,195.4C117.1,195.3,117.1,195.3,117.1,195.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M187.7,212.3c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C186.6,209.7,187.7,210.9,187.7,212.3C187.7,212.3,187.7,212.3,187.7,212.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M186.1,264.8c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C185,262.2,186.1,263.4,186.1,264.8C186.1,264.8,186.1,264.8,186.1,264.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M165.1,385.6c0,1.4-1.2,2.6-2.6,2.5c-1.4,0-2.6-1.2-2.5-2.6c0-1.4,1.2-2.6,2.6-2.5 C164,383,165.1,384.2,165.1,385.6C165.1,385.6,165.1,385.6,165.1,385.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M167.9,375.5c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C166.8,372.9,167.9,374.1,167.9,375.5C167.9,375.5,167.9,375.5,167.9,375.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M170,366.5c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C168.9,364,170,365.1,170,366.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M176,345.3c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C174.9,342.7,176,343.9,176,345.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M177.9,337.1c0,1.4-1.2,2.6-2.6,2.5c-1.4,0-2.6-1.2-2.5-2.6c0-1.4,1.2-2.5,2.6-2.6 C176.7,334.5,177.9,335.7,177.9,337.1C177.9,337.1,177.9,337.1,177.9,337.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M181.3,320.8c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C180.2,318.2,181.3,319.3,181.3,320.8C181.3,320.8,181.3,320.8,181.3,320.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M184.2,311.2c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C183.1,308.6,184.3,309.8,184.2,311.2C184.2,311.2,184.2,311.2,184.2,311.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M185.6,302.1c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C184.4,299.5,185.6,300.7,185.6,302.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M186.2,256.9c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C185.1,254.3,186.2,255.4,186.2,256.9C186.2,256.9,186.2,256.9,186.2,256.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M187.7,233.4c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C186.6,230.8,187.7,231.9,187.7,233.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M187.7,223.2c0,1.4-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C186.6,220.6,187.7,221.7,187.7,223.2C187.7,223.2,187.7,223.2,187.7,223.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M188.2,202.6c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C187.1,200,188.2,201.2,188.2,202.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M188.8,191.9c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C187.6,189.3,188.8,190.5,188.8,191.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M185,162.9c0.2,1.4-0.8,2.7-2.2,2.9c-1.4,0.2-2.7-0.8-2.9-2.2c-0.2-1.4,0.8-2.7,2.2-2.9 C183.5,160.5,184.8,161.4,185,162.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M185,149.9c0,1.4-1.2,2.6-2.6,2.5c-1.4,0-2.6-1.2-2.5-2.6c0-1.4,1.2-2.6,2.6-2.5 C183.9,147.3,185,148.4,185,149.9C185,149.9,185,149.9,185,149.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M183.3,140.5c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C182.2,137.9,183.3,139,183.3,140.5C183.3,140.5,183.3,140.5,183.3,140.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M182.5,129.3c0,1.4-1.2,2.6-2.6,2.5c-1.4,0-2.6-1.2-2.5-2.6c0-1.4,1.2-2.5,2.6-2.6 C181.4,126.7,182.5,127.9,182.5,129.3C182.5,129.3,182.5,129.3,182.5,129.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M180.8,118.1c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C179.6,115.5,180.8,116.6,180.8,118.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M180,110.8c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6C178.9,108.2,180,109.4,180,110.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M179.5,102.2c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 C178.3,99.6,179.5,100.8,179.5,102.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M178.4,93.2c0,1.4-1.2,2.6-2.6,2.5c-1.4,0-2.6-1.2-2.5-2.6c0-1.4,1.2-2.5,2.6-2.6 C177.3,90.6,178.4,91.8,178.4,93.2C178.4,93.2,178.4,93.2,178.4,93.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M178.1,82.1c0,1.4-1.2,2.6-2.6,2.6S173,83.5,173,82c0-1.4,1.2-2.6,2.6-2.6C177,79.5,178.1,80.7,178.1,82.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M173.8,77.4c0,1.4-1.2,2.6-2.6,2.5c-1.4,0-2.6-1.2-2.5-2.6c0-1.4,1.2-2.5,2.6-2.6 C172.6,74.8,173.8,76,173.8,77.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik6);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_6.255dd5b0e7e06882d8baea939587d8f1.svg";
export { ForwardRef as ReactComponent };